export const handleMenagementBusinessPlanning = (prev, values, currentStep, callback) => {
	switch(currentStep){
		case "1"		: return validateStep1(prev, values, callback);					// 1.1.1
		case "1-1"	: return validateStep11(prev, values, callback);					// 1.1.2
		default 		: return "1" ;
	}
};

function validateStep1(prev, values, callback) {
	if(prev) return "return";

	callback(mapToApi(values), "menagement");
	return values["1"] != "D" ? "1-1" : "end";
}

function validateStep11(prev, values, callback) {
	if(prev) return "1";

	callback(mapToApi(values), "menagement");
	return "end";
}

function mapToApi(values) {
	return {
		businessPlanning: {
			"1"		: values["1"] || "",
			"1-1"	:  values["1-1"] ? values["1-1"].description : "",
		}
	};
};


// WEBPACK FOOTER //
// src/helpers/subcategoriesFunctions/handleMenagementBusinessPlanning.js